export const RoleType = ['管理者', '店舗責任者'] as const;
export type RoleType = typeof RoleType[number];
